<div class="header">
  <h2>Gestione <strong>Convenzioni</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li>Convenzioni</li>
      <li class="active">Gestione Convenzioni</li>
    </ol>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-table"></i> Lista <strong>Convenzioni</strong></h3>
      </div>
      <div class="panel-content">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2" style="padding-top: 5px;">
            <label for="items-per-page">Mostra</label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-3">
            <div class="form-group">
              <input [(ngModel)]="paginationConfig.itemsPerPage" (change)="paginationConfig.currentPage = 1"
                     class="form-control input-sm form-white"
                     id="items-per-page" name="items-per-page" type="number">
            </div>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-3" style="padding-top: 5px;">
            <label for="items-per-page">{{ paginationConfig.itemsPerPage > 1 ? 'risultati' : 'risultato' }}</label>
          </div>
          <div class="col-md-5 col-md-offset-1 col-sm-5 col-sm-offset-1 col-xs-12">
            <div class="row">
              <div class="col-md-3 col-sm-3 col-xs-2" style="padding-top: 5px;">
                <label for="user-filter">
                  Cerca:
                </label>
              </div>
              <div class="col-md-9 col-sm-9 col-xs-10">
                <input [(ngModel)]="contractFilterValue" class="form-control input-sm form-white"
                       id="user-filter" name="user-filter" type="text">
              </div>
            </div>
          </div>
        </div>
        <div style="overflow-x:auto;">
          <table class="table table-hover">
            <thead>
            <tr>
              <th style="width: 10%;">
                Codice
                <div class="form-group hidden-xs">
                  <div class="col-sm-10 prepend-icon">
                    <input [(ngModel)]="contractCodeFilterValue" type="text" class="form-control form-white" placeholder="Cerca Codice...">
                    <i class="icon-magnifier"></i>
                  </div>
                </div></th>
              <th style="width: 30%;">
                Descrizione
                <div class="form-group hidden-xs">
                  <div class="col-sm-10 prepend-icon">
                    <input [(ngModel)]="contractTitleFilterValue" type="text" class="form-control form-white" placeholder="Cerca Descrizione...">
                    <i class="icon-magnifier"></i>
                  </div>
                </div>
              </th>
              <th style="width: 20%;">
                Checklist
                <div class="form-group hidden-xs">
                  <div class="col-sm-10 prepend-icon">
                    <input [(ngModel)]="contractChecklistFilterValue" type="text" class="form-control form-white" placeholder="Cerca Checklist...">
                    <i class="icon-magnifier"></i>
                  </div>
                </div></th>
              <th style="width: 10%;">Inizio</th>
              <th style="width: 10%;">Fine</th>
              <th class="text-right" style="width: 20%;">Azioni</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let contract of contracts |
                  contractFilter: contractFilterValue |
                  contractCodeFilter: contractCodeFilterValue |
                  contractTitleFilter: contractTitleFilterValue |
                  checklistTitleFilter: contractChecklistFilterValue |
                  paginate: paginationConfig">
              <td>{{ contract.code }}</td>
              <td>{{ contract.name }}</td>
              <td>{{ contract.checklist.name }}</td>
              <td>{{ contract.start | date: 'dd/MM/yyyy' }}</td>
              <td>{{ contract.end | date: 'dd/MM/yyyy' }}</td>
              <td class="text-right">
                <a class="edit btn btn-sm btn-primary"
                   [routerLink]="['/contract/' + contract.id_contract]"
                   mat-raised-button
                   matTooltip="Dettaglio"
                   matTooltipPosition="above">
                  <i class="fa fa-info-circle"></i></a>
                <a class="edit btn btn-sm btn-default" [routerLink]="['/contract/update/' + contract.id_contract]"
                  mat-raised-button
                  matTooltip="Modifica"
                  matTooltipPosition="above">
                  <i class="icon-note"></i></a>
                <a class="delete btn btn-sm btn-danger"
                   (click)="openDeleteContractModal(contract)"
                   mat-raised-button
                   matTooltip="Elimina"
                   matTooltipPosition="above">
                  <i class="icons-office-57"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <pagination-controls [maxSize]="paginationParams.maxSize"
                             [autoHide]="paginationParams.autoHide"
                             [responsive]="paginationParams.responsive"
                             [previousLabel]="paginationLabels.previousLabel"
                             [nextLabel]="paginationLabels.nextLabel"
                             [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                             [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                             [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
                             (pageChange)="onPageChange($event)"
                             (pageBoundsCorrection)="onPageBoundsCorrection($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>
